export default {
  chat: {}
}
